/* eslint-env node, browser */
'use strict';

require("core-js/modules/es6.array.for-each");

module.exports = function () {
  var self = this;
  self.instances.forEach(function (combokeys) {
    combokeys.reset();
  });
};